import { IsEnum, IsNumber, IsOptional, MinLength } from 'class-validator';

import { ItemStatusEnum } from '@onArte/shared/database/enums';
import { AuctionTypeSearchEnum } from '@onArte/shared/enums';
import { ListQuery } from '@onArte/shared/models/common';

export class ItemListQuery extends ListQuery {
  @IsOptional()
  @MinLength(1)
  public name?: string;

  @IsOptional()
  @MinLength(1)
  public year?: string;

  @IsOptional()
  @MinLength(1)
  public manufacturerId?: string;

  @IsOptional()
  @MinLength(1)
  public ownerId?: string;

  @IsOptional()
  @IsNumber()
  public categoryId?: number;

  @IsOptional()
  @IsEnum(AuctionTypeSearchEnum)
  public auctionType?: AuctionTypeSearchEnum;

  @IsOptional()
  @IsEnum(ItemStatusEnum)
  public status?: ItemStatusEnum;

  constructor(
    limit?: number,
    offset?: number,
    name?: string,
    year?: string,
    manufacturerId?: string,
    ownerId?: string,
    categoryId?: number,
    auctionType?: AuctionTypeSearchEnum,
    status?: ItemStatusEnum,
  ) {
    super(limit, offset);

    this.name = name;
    this.year = year;
    this.manufacturerId = manufacturerId;
    this.ownerId = ownerId;
    this.categoryId = categoryId;
    this.auctionType = auctionType;
    this.status = status;
  }
}
